import { NgClass } from '@angular/common';
import { Component, input, model, output } from '@angular/core';
import { IconBadgeComponent } from '@shared/components/icon-badge/icon-badge.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { TPlatform } from '@shared/components/social-badge-list/social-badge-list.interface';
import { SocialBadgeComponent } from '@shared/components/social-badge/social-badge.component';

@Component({
  imports: [NgClass, IconComponent, IconBadgeComponent, SocialBadgeComponent],
  selector: 'app-pill-checkbox',
  templateUrl: './pill-checkbox.component.html',
})
export class PillCheckboxComponent {
  public readonly label = input.required<string>();

  public readonly icon = input<string>();
  public readonly platform = input<TPlatform>();

  public readonly checked = model<boolean>(false);
  public readonly disabled = input<boolean>(false);

  public readonly containerClasses = input<string>();
  public readonly labelClasses = input<string>();
  public readonly labelContainerClasses = input<string>();

  public readonly checkboxStateChanged = output<boolean>();

  public onPillClick(): void {
    if (this.disabled()) {
      return;
    }

    this.checked.set(!this.checked());
    this.checkboxStateChanged.emit(this.checked());
  }
}
